export function scrubUserInput(inputString: string): string {
  // escape the string before using it because it's from user input
  // this removes / - \ ^ $ * + ? . ( ) | [ ] { } from the string
  return inputString.replace(/[\/\-\\^$*+?.()|[\]{}]/g, '\\$&');
}
